module.exports = __webpack_public_path__ + "static/media/giftCard.709b03ea.svg";